<template>
	<div class="preload-block" v-bind:class="{ unload: show }">
	</div>
</template>

<script>
  export default {
    name: 'preloader',
    props: ['show'],
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style>

	.preload-block {
		position: fixed;
		background-color: black;
		visibility: visible;
		z-index: 100;
		opacity: 1;
		width: 100vw;
		height: 100%;
		text-align: center;
		vertical-align: middle;
	}

	@keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue?1658316a